<template>
  <div>
    <van-popup class="Level-pop" v-model="LevelShow">
      <div class="Level-gorup">
        <h2>{{levelObj.name}}</h2>
        <p v-html="html(levelObj.describe)"></p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getLevel} from "@/api/course"
import Bus from "@/utils/bus"
export default {
    data(){
        return{
            levelObj:{},
            LevelShow:false
        }
    },
    computed:{
      html(){
        return (val)=>{
          return val?val.replace(/\n/g,"<br/>").replace(/ /g,"&nbsp;"):'';
        }
      }
    },
    props:['level_list_id','cpBool'],
    methods:{
        /*
       *@param: cpBool 判读那是否是测评需要请求接口
       *@Description: 获取关卡信息是不否是第一个任务
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-05 12:21:17
      */
      getLevelList(id){
        let s = localStorage.getItem('level_list_arr')
        let stroage = s?JSON.parse(s):[];
        // && !stroage.includes(String(id))
        if(id || (id && this.cpBool)){
          getLevel({
            level_list_id:id
          }).then((data)=>{
            Bus.$emit("documentTitle",data);
            if(data.sort==1 && !stroage.includes(String(id))){
              this.levelObj = data.level;
              this.LevelShow = true;
              stroage.push(String(id));
              localStorage.setItem('level_list_arr', JSON.stringify(stroage));
            }
          });
        }
      }
    },
    created(){
        this.getLevelList(this.level_list_id);
    }
    
}
</script>

<style lang="scss" scoped>
// 关卡介绍
.Level-pop{
  background-color: transparent;
}
.Level-gorup{
  background-color: #fff;
  width: 600px;
  padding: 90px 46px;
  box-sizing: border-box;
  border-radius:8px;
  h2{
    color: #F57F17;
    font-weight: 500;
    text-align: center;
    margin-bottom: 40px;
  }
  p{
    font-size: 26px;
    color: #333333;
    line-height: 40px;
  }
}
</style>